import {
  Car,
  Flame,
  Mountain,
  Camera,
  ShieldCheck,
  Bath,
  Droplets,
  UtensilsCrossed,
  PartyPopper,
  PlaneTakeoff,
  TreePine,
  BedDouble,
} from "lucide-react";

const FACILITIES = [
  { icon: Car, title: "Large Secured Parking", desc: "Space for multiple cars within our compound." },
  { icon: Mountain, title: "Rooftop Relaxation Deck", desc: "Panoramic Coorg hill views, evenings best." },
  { icon: BedDouble, title: "Well-Furnished Rooms", desc: "Cozy interiors with private bathrooms." },
  { icon: Droplets, title: "24×7 Hot Water", desc: "Solar + electric backup in every unit." },
  { icon: Bath, title: "Spotless Bathrooms", desc: "Cleaned and stocked before every check-in." },
  { icon: ShieldCheck, title: "CCTV Secured Premises", desc: "Full perimeter and entry-point coverage." },
  { icon: TreePine, title: "Nature-Rich Surroundings", desc: "Forest views, birdsong, mountain air." },
  { icon: Flame, title: "Campfire Facility", desc: "Bonfire on request — perfect for the evening." },
  { icon: Camera, title: "Trekking Assistance", desc: "Local guides + routes for Mandalpatti, Tadiandamol." },
  { icon: PlaneTakeoff, title: "Jeep Ride · Airport Pickup", desc: "Mangalore / Bangalore / Mysore on request." },
  { icon: UtensilsCrossed, title: "Homemade Coorg Food", desc: "Pandi curry, kadumbuttu, akki roti — prior order." },
  { icon: PartyPopper, title: "Celebrations Arranged", desc: "Birthdays, anniversaries, small gatherings." },
];

export default function FacilitiesSection() {
  return (
    <section id="facilities" data-testid="facilities-section" className="py-24 md:py-32 bg-accent/30">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <div className="grid md:grid-cols-12 gap-12 mb-16">
          <div className="md:col-span-5">
            <p className="overline mb-4">Comforts & Facilities</p>
            <h2 className="font-display text-4xl sm:text-5xl text-foreground font-medium leading-[1.05] tracking-tight">
              Everything you need for a slow, restorative Coorg getaway.
            </h2>
          </div>
          <div className="md:col-span-6 md:col-start-7 self-end">
            <p className="font-sans text-base text-muted-foreground leading-relaxed">
              We've built Aroha Homes the way we'd want our own family to stay — secure, generously spaced,
              warm, and surrounded by nature. Below is everything that's included or available on request.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-px bg-border rounded-2xl overflow-hidden border border-border">
          {FACILITIES.map((f) => {
            const Icon = f.icon;
            return (
              <div
                key={f.title}
                data-testid={`facility-${f.title.toLowerCase().replace(/\s+/g, "-")}`}
                className="bg-background p-7 md:p-8 hover:bg-card transition-colors duration-300 flex flex-col gap-3 min-h-[180px]"
              >
                <Icon className="w-7 h-7 text-primary" strokeWidth={1.3} />
                <h3 className="font-display text-xl font-medium leading-tight">{f.title}</h3>
                <p className="font-sans text-xs text-muted-foreground leading-relaxed">{f.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
